
  import { useIntegrationsHomeStore } from '@/stores/integrationsHome';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    name: 'Sidebar',
    setup() {
      const store = useIntegrationsHomeStore();

      const categories = computed(() => store.categories);

      return {
        categories,
        selectCategory: store.selectCategory,
        isActiveCategory: store.isActiveCategory,
        csEmail: process.env.VUE_APP_CS_EMAIL,
      };
    },
  });
